import { Component, Inject } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faTimesCircle} from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-model',
    templateUrl: './pop-up.component.html',
    styleUrls: ['./pop-up.component.css']
})
export class PopUpComponent {
    iconCloseButton = faTimesCircle;

    constructor(@Inject(MAT_DIALOG_DATA) public data :any){}

    get reactivateText(): string {
        const lang = localStorage.getItem('lang') || 'en-US';
        const dict: Record<string, string> = {
            'en-US': 'Reactivate',
            'hi-IN': 'रीएक्टिवेट',
            'mr-IN': 'रीॲक्टिव्हेट',
            'bn-IN': 'রিয়্যাক্টিভেট'
        };
        return dict[lang] || 'Reactivate';
    }

    get cancelText(): string {
        const lang = localStorage.getItem('lang') || 'en-US';
        const dict: Record<string, string> = {
            'en-US': 'Cancel',
            'hi-IN': 'कैंसल',
            'mr-IN': 'कॅन्सल',
            'bn-IN': 'ক্যান্সেল'
        };
        return dict[lang] || 'Cancel';
    }

    ngOnInit(){
        console.log("data",this.data);
    }
}